






































































import Vue from "vue";
import HomeBanner from "./HomeBanner.vue";

export default Vue.extend({
  components: {
    HomeBanner,
  },
});
